"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _newId = require("../helpers/newId");

var _newId2 = _interopRequireDefault(_newId);

var _Icon = require("../Icon");

var _Icon2 = _interopRequireDefault(_Icon);

var _RawButton = require("../RawButton");

var _RawButton2 = _interopRequireDefault(_RawButton);

require("./Collapsible.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Collapsible = function (_React$Component) {
  _inherits(Collapsible, _React$Component);

  function Collapsible(props, context) {
    _classCallCheck(this, Collapsible);

    var _this = _possibleConstructorReturn(this, (Collapsible.__proto__ || Object.getPrototypeOf(Collapsible)).call(this, props, context));

    _this.ariaId = (0, _newId2.default)("raw-button");
    _this.hasWarnedForAriaText = false;
    _this.checkPropsError();
    return _this;
  }

  _createClass(Collapsible, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkPropsError();
    }
  }, {
    key: "checkPropsError",
    value: function checkPropsError() {
      if (!this.props.ariaText && !(this.context && this.context.t) && !this.hasWarnedForAriaText) {
        this.hasWarnedForAriaText = true;
        console.error("Error: It is necessary to provide either an ariaText prop or the i18n.t function via the L10n component for Collapsible.");
      }
    }
  }, {
    key: "handleClickCollapse",
    value: function handleClickCollapse(event) {
      this.props.onClick(event);
    }
  }, {
    key: "renderDefaultCollapsible",
    value: function renderDefaultCollapsible() {
      var _this2 = this;

      var _props = this.props,
          ariaText = _props.ariaText,
          label = _props.label,
          isCollapsed = _props.isCollapsed,
          isDisabled = _props.isDisabled,
          iconAlign = _props.iconAlign;


      return _react2.default.createElement(
        _RawButton2.default,
        {
          ariaLabel: ariaText || this.context.t("collapsible.ariaText"),
          "aria-expanded": !isCollapsed,
          className: "aclui-collapsible__label",
          isDisabled: isDisabled,
          onClick: function onClick(e) {
            return _this2.handleClickCollapse(e);
          }
        },
        _react2.default.createElement(
          "span",
          { className: "aclui-collapsible--icon-" + iconAlign, "aria-hidden": "true" },
          this.collapsedIcon[+isCollapsed]
        ),
        label
      );
    }
  }, {
    key: "renderCollapsibleByIcon",
    value: function renderCollapsibleByIcon() {
      var _this3 = this;

      var _props2 = this.props,
          ariaText = _props2.ariaText,
          label = _props2.label,
          isCollapsed = _props2.isCollapsed,
          isDisabled = _props2.isDisabled,
          iconAlign = _props2.iconAlign;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _RawButton2.default,
          {
            ariaLabel: ariaText || this.context.t("collapsible.ariaText"),
            "aria-expanded": !isCollapsed,
            className: "aclui-collapsible__label aclui-collapsible__label--is-toggle-icon-only",
            isDisabled: isDisabled,
            onClick: function onClick(e) {
              return _this3.handleClickCollapse(e);
            }
          },
          _react2.default.createElement(
            "span",
            { className: "aclui-collapsible--icon-" + iconAlign, "aria-hidden": "true" },
            this.collapsedIcon[+isCollapsed]
          )
        ),
        label
      );
    }
  }, {
    key: "render",
    value: function render() {
      /* eslint-disable no-unused-vars */
      /* Destructuring is used to isolate additional props in moreProps and pass them along to
         Collapsible.  Several are not by render() but they must remain in this statement to
         exclude them from moreProps.
      */
      var _props3 = this.props,
          ariaText = _props3.ariaText,
          children = _props3.children,
          className = _props3.className,
          iconAlign = _props3.iconAlign,
          iconCollapse = _props3.iconCollapse,
          iconExpand = _props3.iconExpand,
          isCollapsed = _props3.isCollapsed,
          isDisabled = _props3.isDisabled,
          hasOnlyIconToggle = _props3.hasOnlyIconToggle,
          onClick = _props3.onClick,
          label = _props3.label,
          moreProps = _objectWithoutProperties(_props3, ["ariaText", "children", "className", "iconAlign", "iconCollapse", "iconExpand", "isCollapsed", "isDisabled", "hasOnlyIconToggle", "onClick", "label"]);
      /* eslint-enable no-unused-vars */

      var rootClasses = (0, _classnames2.default)("aclui-collapsible", className, { "aclui-collapsible--is-open": !isCollapsed }, { "is-disabled": isDisabled });

      return _react2.default.createElement(
        "div",
        _extends({
          className: rootClasses,
          role: "group"
        }, moreProps),
        hasOnlyIconToggle ? this.renderCollapsibleByIcon() : this.renderDefaultCollapsible(),
        _react2.default.createElement(
          "div",
          { className: "aclui-collapsible__body" },
          children
        )
      );
    }
  }, {
    key: "collapsedIcon",
    get: function get() {
      var _props4 = this.props,
          iconExpand = _props4.iconExpand,
          iconCollapse = _props4.iconCollapse;


      return [iconExpand, iconCollapse];
    }
  }]);

  return Collapsible;
}(_react2.default.Component);

Collapsible.contextTypes = {
  t: _propTypes2.default.func
};

Collapsible.propTypes = {
  ariaText: _propTypes2.default.string,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  iconAlign: _propTypes2.default.oneOf(["left", "right"]),
  iconCollapse: _propTypes2.default.node,
  iconExpand: _propTypes2.default.node,
  isCollapsed: _propTypes2.default.bool,
  isDisabled: _propTypes2.default.bool,
  hasOnlyIconToggle: _propTypes2.default.bool,
  label: _propTypes2.default.node.isRequired,
  onClick: _propTypes2.default.func
};

Collapsible.defaultProps = {
  ariaText: null,
  children: null,
  className: null,
  iconAlign: "left",
  iconCollapse: _react2.default.createElement(_Icon2.default, { type: "arrow-right" }),
  iconExpand: _react2.default.createElement(_Icon2.default, { type: "arrow-down" }),
  isCollapsed: true,
  isDisabled: false,
  hasOnlyIconToggle: false,
  onClick: function onClick() {}
};

exports.default = Collapsible;